var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSoccer1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 30,
    viewBox: "0 0 22 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_9033_5248)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5625 12L14.6875 10.3438L17.8125 10.8125C18.5 12 18.9062 13.3125 18.9688 14.6562L16.7188 16.625L14.8125 15.8438L13.5625 12ZM11.3438 18.8438L14.5938 16.5L16.4375 17.2812L16.7188 20.5938C15.9688 21.3438 15.1562 21.9375 14.2188 22.3438L11.3438 20.9375V18.8438ZM7.84375 9.9375L9.3125 7.1875C10.4062 6.96875 11.5625 6.96875 12.6562 7.1875L14.125 9.9375L12.9688 11.5938H9L7.84375 9.9375ZM17.125 17.1875L18.9688 15.5938C18.8438 17.1562 18.3125 18.625 17.3438 19.8438L17.125 17.1875ZM4.71875 10.0312C5.6875 8.84375 6.9375 7.9375 8.375 7.4375L7.21875 9.65625L4.71875 10.0312ZM3 14.6562C3.0625 13.3125 3.46875 11.9688 4.15625 10.8125L7.28125 10.3438L8.40625 12L7.15625 15.8125L5.25 16.625L3 14.6562ZM5.25 20.5938L5.53125 17.2812L7.375 16.5L10.625 18.8438V20.9375L7.75 22.3438C6.8125 21.9062 5.96875 21.3438 5.25 20.5938ZM3 15.5938L4.84375 17.1875L4.625 19.8438C3.6875 18.625 3.125 17.1562 3 15.5938ZM8.65625 22.6562L10.9688 21.5312V21.5625L11 21.5312L13.3125 22.6562C12.5625 22.9062 11.7812 23 11 23C10.1875 23 9.40625 22.9062 8.65625 22.6562ZM7.84375 15.9688L9.0625 12.2812H12.9062L14.125 15.9688L11 18.25L7.84375 15.9688ZM17.25 10.0312C16.2812 8.84375 15.0312 7.9375 13.5938 7.4375L14.75 9.65625L17.25 10.0312Z",
    fill: "#FF82EB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_9033_5248",
    x: -7,
    y: -3.03125,
    width: 35.9688,
    height: 36.0312,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.509804 0 0 0 0 0.921569 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9033_5248"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9033_5248",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoccer1);
export default ForwardRef;